module.exports = __webpack_public_path__ + "static/media/rim-front-left.d992269f.svg";